<form
    class="vendor-form"
    #vendorForm="ngForm"
    name="vendorForm"
    (ngSubmit)="!vendorForm.valid || add()"
    [ngClass]="{ submitted: vendorForm.submitted }"
    novalidate>
    <div class="row">
        <div class="col-6">
            <label for="name" translate>Name</label>
            <input
                type="text"
                [(ngModel)]="name"
                id="name"
                name="name"
                class="form-control"
                placeholder="{{ 'Name' | translate }}"
                autocomplete="off"
                appFocus
                maxlength="255"
                [appAutoFocus]="true" />
        </div>
        <div class="col-6">
            <label for="email" translate>Email</label>
            <input
                [(ngModel)]="email"
                id="email"
                name="email"
                class="form-control"
                placeholder="{{ 'Email' | translate }}"
                [required]="vendorForm.submitted"
                autocomplete="off"
                [pattern]="emailValidationPattern" />
        </div>
    </div>

    <fieldset
        class="confirmation-access-block mt-3"
        [ngClass]="{ 'ng-invalid': !isGivingAccess && vendorForm.submitted }">
        <legend class="confirmation-access-block__legend" translate>Please confirm data access to new user</legend>

        <div class="form-group">
            <label class="checkbox__label checkbox__label--size-small" for="isGivingAccess">
                {{ "I confirm to giving this user access because it's needed to solve support tickets." | translate }}
                <input
                    type="checkbox"
                    id="isGivingAccess"
                    name="isGivingAccess"
                    required
                    [(ngModel)]="isGivingAccess" />
                <span class="checkbox__checkmark"></span>
            </label>
        </div>
        <div class="confirmation-access-block__hint-block">
            <div
                class="confirmation-access-hint"
                tooltip="{{ 'According to the new Data Protection need to log data access to new users.' | translate }}"
                container="body">
                ?
            </div>
        </div>
    </fieldset>
    <div class="top10 text-end mt-2">
        <button class="btn btn-default btn-sm me-2" [disabled]="isAddingUser" type="button" (click)="close()" translate>
            Cancel
        </button>
        <button class="btn btn-primary btn-sm" [disabled]="isAddingUser" type="submit" translate>Add</button>
    </div>
</form>
